import React from "react";

function EbayAnalytics() {
  return <div>EbayAnalytics</div>;
}

export default EbayAnalytics;
